module.exports = __webpack_public_path__ + "static/dance-3-10c01561c8ceddf8704ad117e0b5bca4.gif";